import * as SystemInfoActions from './system-info.actions';
import * as SystemInfoSelectors from './system-info.selectors';
import { systemInfoReducer } from './system-info.reducer';
import { SystemInfoEffects } from './system-info.effects';
import { IStartPageInfoState } from './system-info.state';

export {
  SystemInfoActions,
  SystemInfoSelectors,
  systemInfoReducer,
  SystemInfoEffects,
  IStartPageInfoState
};
